<template lang="html">
  <div>
    <v-page class="search-register" :profile="profile">
      <div class="autoRegister">
        <v-login class="card-register">
          <div class="center">
            <div class="registerLeft">
              <div class="company">
                <p>B</p>
                <p>U</p>
                <p>S</p>
                <p>C</p>
                <p>A</p>
                <p>R</p>
              </div>
              <div>
                <img class="photo" :src="img_url" />
              </div>
            </div>

            <div class="registerRight">
              <div class="titleRegister">
                Encontre o <br />
                <span class="spanColor">profissional ideal</span>
              </div>

              <!-- Campo para selecionar o perfil desejado (simples com v-input tipo select) -->
              <v-input
                type="select"
                :options="['Analista/Gestor', 'Analista de negócio', 'Gestor de projetos', 'Designer', 'Desenvolvedor', 'Equipe', 'Outro']"
                v-model="selectedProfile"
                class="inputRegister"
                placeholder="Perfil desejado"
              />

              <!-- Campo para descrever a demanda (usando v-input para textarea) -->
              <v-input
                type="textarea"
                v-model="demand_description"
                class="inputRegister"
                id="demand-description"
                placeholder="Descreva sua demanda"
              />

              <v-button
                class="block primary"
                :disabled="isSubmitting"
                @click="submitSearch"
                style="background-color: #0377aa; color: white"
              >
                <template v-if="isSubmitting">
                  <!-- Spinner enquanto a busca está sendo feita -->
                  <span class="spinner" style="margin-right: 5px;"></span> Enviando...
                </template>
                <template v-else>
                  Buscar Profissionais
                </template>
              </v-button>
            </div>
          </div>
        </v-login>
      </div>
    </v-page>
  </div>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      isSubmitting: false,
      selectedProfile: '', // Campo selecionado no dropdown
      profiles: [
        'Analista/Gestor',
        'Analista de negócio',
        'Gestor de projetos',
        'Designer',
        'Desenvolvedor',
        'Outro'
      ],
      demand_description: '',
      img_url: require('@/assets/photoPeople/Planos-Enterprise.png'),
    };
  },
  methods: {
    submitSearch() {
      this.isSubmitting = true;
      // Lógica para submissão da busca
      console.log("Perfil desejado:", this.selectedProfile);
      console.log("Descrição da demanda:", this.demand_description);
      console.log("User", this.$store.getters.user)
      // Aqui, você pode adicionar a lógica para processar a busca.

      if(`${this.selectedProfile}`.trim() && `${this.demand_description}`.trim()){
        clientApi
        .searchCustomVibbrantes({
          profile: this.selectedProfile,
          description: this.demand_description,
          user: this.$store.getters.user
        })
        .then(response => {
          this.$notify("Solicitação recebida! Em breve, entraremos em contato com você.", 'success');
          this.isSubmitting = false;
          window.open("/#/client/vibbrants", "_self")
        })
        .catch(e => {
          this.isSubmitting = false;
          this.$notify(e, 'error');
        });
      } else {
        this.$notify('Preencha os campos obrigatórios!', 'error');
        this.isSubmitting = false;
      }

    },
  },
};
</script>

<style lang="scss">
.search-register {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .link {
    color: #0377aa !important;
  }

  .autoRegister {
    width: 100%;
  }

  .card-register {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;

    @include media-breakpoint-up(md) {
      width: 100%;
    }

    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }

    .registerLeft {
      display: flex;
      align-items: flex-end;
      height: 100%;
      width: 60%;

      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .photo {
      display: block;
      height: 700px;
      margin-top: 6px;
    }

    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }

    .registerRight {
      width: 40%;

      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }
  }

  .titleRegister {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 40px;

    @include media-breakpoint-down(md) {
      font-size: 30px;
    }
  }

  .spanColor {
    color: #0377aa;
  }

  .inputRegister {
    border-radius: 20px !important;
    margin-bottom: 20px;

    .multiselect__placeholder {
      color: #727379;
      font-size: 16px;
      margin-left: 5px;
      line-height: 16px;
    }
  }

  footer.page-footer {
    margin-top: auto;
    color: white;
  }

  #demand-description {
    min-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/search-form.vue